import type { TerminalConnectionState } from './use-pty-terminal';

/**
 * Status-bar label + dot styling per connection state (FRONT-960). Pulled
 * out as a pure function so it's testable without a DOM harness — see
 * `app-terminal.test.tsx`.
 */
export function statusLabel(state: TerminalConnectionState): string {
  switch (state) {
    case 'open':
      return 'Connected';
    case 'connecting':
      return 'Connecting…';
    case 'ended':
      return 'Session ended';
    case 'error':
      return 'Disconnected';
  }
}

/** Dot + text color classes per connection state (FRONT-960, color-coding rule). */
export function statusColorClasses(state: TerminalConnectionState): { dot: string; text: string } {
  switch (state) {
    case 'open':
      return { dot: 'bg-success', text: 'text-success' };
    case 'connecting':
      return { dot: 'bg-amber-500', text: 'text-amber-600 dark:text-amber-400' };
    case 'ended':
      return { dot: 'bg-muted-foreground', text: 'text-muted-foreground' };
    case 'error':
      return { dot: 'bg-destructive', text: 'text-destructive' };
  }
}
